import React from "react";

import { createClassNameString } from "../../../../../component-library";
import { getAutomationDataAttr } from "../../../../../utils/automationUtils";
import images from "../../../../../utils/images";

import "../../styles.scss";

export const WorkflowStepTransitionButtons = ({
  className,
  currentStep,
  onNextStep,
  onPreviousStep,
  workflow,
}) => {
  return (
    <div
      className={createClassNameString([
        "GuidedVideoCall__guided_widget_footer d-flex justify-content-around w-100",
        className,
      ])}
    >
      <div
        className="my-1 mx-3 p-1 d-flex justify-content-around align-items-center"
        onClick={() => onPreviousStep(currentStep)}
        style={{
          backgroundColor: "#6B7A81",
          borderRadius: 5,
          textAlign: "right",
          width: "35%",
        }}
        {...getAutomationDataAttr("WorkflowStepTransitionButtons_prev")}
      >
        <div>
          <img src={images("./common/back.svg")} />
        </div>
        <div>
          <div>Previous Step</div>
          <div className="fs-10">{workflow.steps[currentStep - 1].short}</div>
        </div>
      </div>
      <div
        className="my-1 mx-3 p-1 d-flex justify-content-around align-items-center"
        onClick={() => onNextStep(currentStep)}
        style={{
          backgroundColor: "#0CD0A7",
          borderRadius: 5,
          textAlign: "left",
          width: "35%",
        }}
        {...getAutomationDataAttr("WorkflowStepTransitionButtons_next")}
      >
        <div>
          <div>Next Step</div>
          <div className="fs-10">{workflow.steps[currentStep + 1].short}</div>
        </div>
        <div>
          <img
            src={images("./common/back.svg")}
            style={{
              height: 15,
              transform: "rotate(180deg)",
              width: 15,
            }}
          />
        </div>
      </div>
    </div>
  );
};
